import React, { useEffect, useState } from 'react';
import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  ApolloProvider as BaseApolloProvider,
} from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import { useAuth } from '#contexts/auth';

import {
  createErrorLink,
  createHttpLinkWithUri,
  createInstallationLink,
  createTimeZoneLink,
} from './links';

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([]),
});

export const ApolloProvider = ({ children }) => {
  const toast = useToast();
  const { signOut } = useAuth();
  const [isClientInitialized, setIsClientInitialized] = useState(false);

  useEffect(() => {
    const httpLink = createHttpLinkWithUri(`${process.env.REACT_APP_API_URL}/graphql`);
    const installationLink = createInstallationLink();
    const timeZoneLink = createTimeZoneLink();
    const errorLink = createErrorLink(signOut, toast);

    client.setLink(ApolloLink.from([errorLink, installationLink, timeZoneLink, httpLink]));
    setIsClientInitialized(true);
  }, [signOut, toast]);

  if (!isClientInitialized) {
    return null;
  }

  return <BaseApolloProvider client={client}>{children}</BaseApolloProvider>;
};
